import { useMemo, useState } from "react";
import { site } from "../data/site";
import { Navbar } from "../components/Navbar/Navbar";
import { Section } from "../components/Section/Section";
import { Hero } from "../components/sections/Hero";
import { About } from "../components/sections/About";
import { Education } from "../components/sections/Education";
import { Publications } from "../components/sections/Publications";
import { Teaching } from "../components/sections/Teaching";
import { Awards } from "../components/sections/Awards";
import { Activities } from "../components/sections/Activities";
import { Skills } from "../components/sections/Skills";
import { Contact } from "../components/sections/Contact";
import { Footer } from "../components/Footer/Footer";
import { useActiveSection } from "../hooks/useActiveSection";
import { useTheme } from "../hooks/useTheme";
import { ScrollToTop } from "../components/ScrollToTop/ScrollToTop";
import { useReveal } from "../hooks/useReveal";

export type SectionId = (typeof site.nav)[number]["id"];

export function App() {
  const { theme, toggleTheme } = useTheme();
  useReveal();
  const sectionIds = useMemo(() => site.nav.map((x) => x.id), []);
  const activeId = useActiveSection(sectionIds, { rootMargin: "-30% 0px -60% 0px" });
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="app" data-theme={theme}>
      <Navbar
        brand={site.profile.nameZh}
        items={site.nav}
        activeId={activeId}
        mobileOpen={mobileOpen}
        onToggleMobile={() => setMobileOpen((v) => !v)}
        onCloseMobile={() => setMobileOpen(false)}
        theme={theme}
        onToggleTheme={toggleTheme}
      />

      <main className="container">
        <Section id="home" ariaLabel="首屏">
          <Hero profile={site.profile} researchInterests={[...site.researchInterests]} />
        </Section>

        <Section id="about" title="关于我" subtitle="真实、稳定、耐心、理性">
          <About paragraphs={[...site.about.paragraphs]} />
        </Section>

        <Section id="education" title="教育背景" subtitle="课程与学习轨迹">
          <Education items={site.education} />
        </Section>

        <Section id="research" title="科研成果" subtitle="论文与投稿">
          <Publications items={site.publications} />
        </Section>

        <Section id="teaching" title="教学实践" subtitle="长期与持续的数学教学经历">
          <Teaching items={site.teaching} />
        </Section>

        <Section id="awards" title="竞赛与荣誉" subtitle="竞赛、奖学金与学术奖励">
          <Awards items={site.awards} />
        </Section>

        <Section id="activities" title="校园与学术活动" subtitle="分享、参与与组织经历">
          <Activities items={site.activities} />
        </Section>

        <Section id="skills" title="技能与兴趣" subtitle="研究方法、表达方式与个人风格">
          <Skills groups={site.skillsAndInterests} />
        </Section>

        <Section id="contact" title="联系方式" subtitle="公开主页的联系入口与说明">
          <Contact profile={site.profile} notes={[...site.contact.notes]} social={site.contact.social} />
        </Section>
      </main>

      <Footer profile={{ name: site.profile.nameZh, city: site.profile.city, email: site.profile.email }} />
      <ScrollToTop />
    </div>
  );
}

